import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  fill: "currentColor",
  "fill-opacity": ".85",
  "fill-rule": "nonzero"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M12 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10m0-18.565c-4.723 0-8.565 3.842-8.565 8.565S7.277 20.565 12 20.565s8.565-3.843 8.565-8.565c0-4.723-3.843-8.565-8.565-8.565" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M16.799 9.348a.714.714 0 0 0-1.01.006l-5.208 5.264-2.305-2.369a.714.714 0 1 0-1.024.996l2.813 2.89q.002.003.006.005l.003.006c.045.044.101.071.154.101.028.015.05.04.078.052a.7.7 0 0 0 .538.001c.027-.011.049-.034.075-.049.054-.03.11-.056.155-.101l.005-.006.005-.004 5.72-5.781a.715.715 0 0 0-.005-1.011" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }